/* @flow */

import { type Loading } from './types';

import MENSAGENS from '../mensagens';

const hide = (elemento: string = '.m-portlet') => {
    global.mApp.unblock(elemento);
};

const show = (elemento: string = '.m-portlet', message: ?string = MENSAGENS.UTILS.LOADING.PADRAO) => {
    global.mApp.block(elemento, {
        overlayColor: '#000000',
        type: 'loader',
        state: 'success',
        message,
    });
};

const loading: Loading = {
    hide,
    show,
};

export default loading;
